<template>
    <el-container>
        <el-header>
            <el-form @submit.native.prevent :inline="true" :model="formSMSTemplate" ref="formSMSTemplate" class="demo-form-inline">
                <el-form-item :label="$t('common.TEMPLATE_SIGN')" prop="sSign"><td-input v-model="formTemplate.sSign"></td-input></el-form-item>
                <el-form-item :label="$t('common.TEMPLATENAME')" prop="sName"><td-input v-model="formTemplate.sName"></td-input></el-form-item>
                <el-form-item :label="$t('common.TEMPLATE_TYPE')" prop="sType">
                    <td-select v-model="formTemplate.sType" :options="templateTypes" keys="id" text="name"></td-select>
                </el-form-item>
                <el-form-item :label="$t('common.TEMPLATE_PARAMETER_ENGINE')" prop="sParamEngine">
                    <td-input v-model="formTemplate.sParamEngine" maxlength="50"></td-input>
                </el-form-item>

                <el-form-item class="paddingLeft10">
                    <td-button type="primary" :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" :loading="loading" @click="btnClickQuery">
                        {{ $t('common.QUERY') }}
                    </td-button>
                    <td-button type="button" @click="btnAddSMS">{{ $t('common.ADD') }}</td-button>
                    <td-button type="button" @click="btnDeleteSMS">{{ $t('common.DELETE') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                ref="tableInfo"
                :dataSource="tableData"
                :total="total"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :rowKey="rowKey"
                :hasPage="true"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                @handleSelect="handleSelect"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-template
                v-if="dialogSmsVisible"
                :dialogSmsVisible="dialogSmsVisible"
                :editItem="editItem"
                :title="title"
                :templateTypes="templateTypes"
                @SmsDialogClose="SmsDialogClose"
                @submit="submit"
            ></dialog-template>
        </el-main>
    </el-container>
</template>
<script>
import api from './assets/api.js';
import dialogTemplate from './components/dialogTemplate.vue';
export default {
    created() {
        this.btnQuery();
    },
    // 初始化渲染
    components: {
        'dialog-template': dialogTemplate
    },
    // 定义数据
    data() {
        return {
            //模板类型列表
            templateTypes: [{ id: 'SMS', name: '短信模板' }, { id: 'DBTASK', name: '数据库任务模板'},{ id: 'LOG', name: '日志模板'}],
            formTemplate: {},
            editItem: {},
            dialogSmsVisible: false,
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            rowKey: 'sId',
            columns: [
                {
                    prop: 'sSign',
                    label: 'common.TEMPLATE_SIGN',
                    align: 'center'
                },
                {
                    prop: 'sName',
                    label: 'common.TEMPLATENAME',
                    align: 'center'
                },
                {
                    prop: 'sType',
                    label: 'common.TEMPLATE_TYPE',
                    align: 'center',
                    render: (createElement, params) => {
                        let value = '';
                        for (let i = 0, j = this.templateTypes.length; i < j; i++) {
                            if (params.row.sType == this.templateTypes[i].id) {
                                value = this.templateTypes[i].name;
                            }
                        }
                        return createElement('span', value);
                    }
                },
                {
                    prop: 'sParamEngine',
                    label: 'common.TEMPLATE_PARAMETER_ENGINE'
                },
                {
                    prop: 'sContent',
                    label: 'common.TEMPLATE_CONTENT'
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '90',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDelete([params.row.sId]);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.btnQuery();
        },
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.btnQuery(); // 进行页面初始化数据的加载
            }
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.btnQuery();
        },
        //查询点击按钮
        btnClickQuery() {
            this.btnQuery();
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                sSign: this.formTemplate.sSign,
                sName: this.formTemplate.sName,
                sType: this.formTemplate.sType,
                sParamEngine: this.formTemplate.sParamEngine,
                page: this.currentPage,
                pageSize: this.pageSize
            };
            api.getSmsTemplate(JSON.stringify(param), response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.loading = false;
                    this.$log.error('/template/queryTemplate', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/template/queryTemplate', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content.resultlist;
                this.total = response.data.content.total;
                this.loading = false;
            });
        },
        // 添加
        btnAddSMS() {
            this.editItem = {};
            this.title = this.$t('common.ADD'); // 标题
            this.dialogSmsVisible = true;
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT');
            this.dialogSmsVisible = true;
        },
        // 获取选中表格数据的id
        getTableSelectId() {
            let selectData = this.$refs.tableInfo.getSelectAllRows();
            let tableSign = [];
            for (let i = 0; i < selectData.length; i++) {
                tableSign.push(selectData[i].sId);
            }
            return tableSign;
        },
        // 批量删除
        btnDeleteSMS() {
            let tableSign = this.getTableSelectId();
            if (tableSign.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_SELECT'), type: 'warning' });
                return;
            }
            this.btnDelete(tableSign);
        },
        // 删除接口
        btnDelete(sign) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    api.deleteSmsTemplate(JSON.stringify(sign), response => {
                        if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('smsTemplate/deleteSmsTemplate', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {});
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 关闭页面
        SmsDialogClose() {
            this.dialogSmsVisible = false;
        }
    }
};
</script>
